var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-lot-result-container"},_vm._l((_vm.allLots),function(tab){return _c('div',{key:tab.id,staticClass:"tab-row"},[_c('h3',[_vm._v(_vm._s(tab.context))]),_c('ul',{staticClass:"child-container"},_vm._l((tab.children),function(child){return _c('li',{key:child.id},[_c('router-link',{staticClass:"child-item",attrs:{"to":{
            name: 'LotteryResult',
            query: {
              tab: tab.id,
              id: child.id
            }
          }},nativeOn:{"click":function($event){return _vm.handleClickLotteryResult.apply(null, arguments)}}},[_vm._v(" "+_vm._s(child.name)+" ")])],1)}),0)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }